// extracted by mini-css-extract-plugin
export default {"isCopiedContainer":"IsCopiedMessage_isCopiedContainer__K0fu+","active":"IsCopiedMessage_active__OoVme"};